import React from "react";
import { Box } from "@mui/material";
import Menu from "../components/Menu";

const LayoutDashboard = ({ children }) => {

return (

<Box sx={{ display:"flex", minHeight:"100vh" }}>

<Menu />

<Box
component="main"
sx={{
flexGrow:1,
width:"100%",

/* espace pour menu mobile */
pt:{ xs:"64px", lg:"0px" },

px:3,
py:3
}}
>

{children}

</Box>

</Box>

);

};

export default LayoutDashboard;